import styled from 'styled-components'

const LargeImage = styled.img`
  height: 90vh;
`

export default LargeImage
